import './App.scss';
import SectionAdvantagesSubscription from './sections/SectionAdvantagesSubscription';
import SectionFAQ from './sections/SectionFAQ';
import SectionRdv from './sections/SectionRdv';
import SectionHeroRdv from './sections/SectionHeroRdv';
import LandingPage from './templates/LandingPage';
import {Toaster} from 'react-hot-toast'
function App() {
  return (
    <div className="App">
      <LandingPage>
        <SectionRdv/>
        <SectionFAQ/>
      </LandingPage>
    <Toaster/>
    </div>
  );
}

export default App;
